import { useMutation } from 'react-query';

import { getComponent } from 'api/endPoints/getComponent';
import { setComponent } from 'api/endPoints/setComponent';

import { WidgetNarrativeOverrides } from 'components/Dashboards/Reporting/reporting.types';

interface UseMutationSetComponentSpecificFieldQueryParams {
    componentId: string | undefined;
    fieldsToUpdate?: WidgetNarrativeOverrides;
}

export const useMutationSetComponentSpecificFields = () => {
    return useMutation<QueryResponse, QueryError, UseMutationSetComponentSpecificFieldQueryParams>({
        mutationFn: async (params) => {
            const widgetToUpdate = await getComponent(params);
            const updatedWidget = {
                ...widgetToUpdate,
                ...params.fieldsToUpdate,
            };
            return setComponent(updatedWidget);
        },
    });
};

export interface QueryResponse {
    id: number;
    componentKey: string;
    contractId: number;
    description: string;
    lastUpdateDate: number;
    lstUpdateUser: string;
    name: string;
    projectId: number;
    reportId: number;
    params: string;
    showNarrative: boolean;
}
